import { render, staticRenderFns } from "./WrsAxleItem.vue?vue&type=template&id=8931970a&v-resize=onResize&"
import script from "./WrsAxleItem.vue?vue&type=script&lang=js&"
export * from "./WrsAxleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports